<div class="container">

	<div class="portalCard">
		
		<div class="rowScreenColPhone">
			
			<div class="aTitle">
				<mat-icon>save_alt</mat-icon>
				<span>Export</span>
			</div>

			<mat-spinner diameter=30 *ngIf="bDownloading" />

		</div>

		<div style="display: flex; flex-flow: row wrap; gap: 2em; justify-content: center; margin: 2em auto">

			<button
				mat-raised-button
				color="primary"
				(click)="download()"
				[disabled]="bDownloading"
			>
				Daten herunterladen
			</button>

		</div>

	</div>

</div>
